var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGeofencingLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_568_9",
    "data-name": "Component 568 \\u2013 9",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10876",
    "data-name": "Rectangle 10876",
    width: 24,
    height: 24,
    fill: "#c5aeae",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13900",
    "data-name": "Group 13900",
    transform: "translate(152.057 -7359.942)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13899",
    "data-name": "Group 13899",
    transform: "translate(-150.057 7361.942)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11313",
    "data-name": "Path 11313",
    d: "M52.1,45.77a6.324,6.324,0,1,0,6.324,6.324A6.323,6.323,0,0,0,52.1,45.77m0,10.056a3.732,3.732,0,1,1,3.733-3.733A3.732,3.732,0,0,1,52.1,55.826",
    transform: "translate(-42.103 -42.094)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11314",
    "data-name": "Path 11314",
    d: "M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0m0,17.621A7.62,7.62,0,1,1,17.621,10,7.62,7.62,0,0,1,10,17.621",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11315",
    "data-name": "Path 11315",
    d: "M98.747,95.887a2.47,2.47,0,1,1-2.47-2.469,2.47,2.47,0,0,1,2.47,2.469",
    transform: "translate(-86.273 -85.914)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeofencingLogo);
export default __webpack_public_path__ + "static/media/GeofencingLogo.d22320bc4717d1740e96e1db924889b7.svg";
export { ForwardRef as ReactComponent };